import React from 'react';

/** The comic's "Our story" summary above page 1. Collapsible; no client-unsafe imports. */
export function ComicStorySummary({
  summary,
  defaultOpen,
}: {
  summary: { heading: string; text: string; starring: string };
  defaultOpen: boolean;
}) {
  return (
    <details open={defaultOpen} className="bg-white border border-gray-200 rounded-lg p-4 text-left">
      <summary className="cursor-pointer text-sm font-semibold uppercase tracking-wide text-gray-600">
        {summary.heading}
      </summary>
      <p className="mt-2 text-gray-800">{summary.text}</p>
      {summary.starring && <p className="mt-2 text-sm text-gray-600">{summary.starring}</p>}
    </details>
  );
}
